import queryString from 'query-string';

export const getVideoFileName = (src: string) => {
  const searchParams = queryString.parse(src.split('?')[1], { arrayFormat: 'comma' });
  return searchParams.fileName as string;
};
